import { createContext } from "react";
import {
  ProctoringFailureReason,
  ProctoringSessionState
} from "@assessment/types/proctoring";

export type ProcessStatus =
  | "Init"
  | "Preparing camera preview"
  | "Ready for calibration"
  | "Calibrating"
  | "Calibration completed"
  | "Retry required"
  | "Proctoring unavailable"
  | "Proctoring started"
  | "Proctoring stopped";

export interface ProctoringFunctionsContext {
  startCalibration: () => void | Promise<void>;
  startProctoring: () => Promise<boolean>;
  stopProctoring: () => void;
  retryProctoring: () => Promise<void>;
  registerPreviewSink: (node: HTMLVideoElement | null) => void;
  processStatus: ProcessStatus;
  sessionState: ProctoringSessionState;
  failureReason: ProctoringFailureReason | null;
  canCalibrate: boolean;
  canStart: boolean;
  canRetry: boolean;
}

export const ProctoringFunctionsContext =
  createContext<ProctoringFunctionsContext | null>(null);
